import React from 'react';
import { useIntl } from 'react-intl';

import { useVoucherValidation } from '@sharedComponents/Benefits';
import { CartLayout } from '@sharedComponents/Layout';
import { ReactFCV } from '@types';

import { useCartPageContext } from '../../../context';
import { messages } from '../messages';

import { BodyColumn } from './componentsHelpers';

export const VoucherAddButton: ReactFCV = () => {
  const {
    actions: { addVoucher, setProductVoucherCode },
    state: { copiedProductVoucherCode },
  } = useCartPageContext();

  const { formatMessage } = useIntl();

  const { loading, validationErrors, validationCallback } = useVoucherValidation({
    serverValidationAction: addVoucher,
    baseVoucherError: messages.voucherCodeInvalidErrorMsgText,
  });

  return (
    <CartLayout
      serviceActive={true}
      serviceDisabled={false}
      bodyColumn={BodyColumn(
        validationErrors,
        loading,
        formatMessage,
        validationCallback,
        copiedProductVoucherCode,
        () => setProductVoucherCode({ productVoucherCode: '' }),
      )}
    />
  );
};
